import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface JobCardPhotoProps {
  jobId: string;
  className?: string;
}

export const JobCardPhoto = ({ jobId, className = "" }: JobCardPhotoProps) => {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        // Fetch one photo for this job
        const { data: photos, error } = await supabase
          .from("job_photos")
          .select("file_path")
          .eq("job_id", jobId)
          .limit(1);

        if (error) throw error;

        if (photos && photos.length > 0) {
          // Get public URL for the photo
          const { data: urlData } = supabase.storage
            .from("job-photos")
            .getPublicUrl(photos[0].file_path);

          setPhotoUrl(urlData.publicUrl);
        }
      } catch (error) {
        console.error("Error fetching job photo:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPhoto();
  }, [jobId]);

  if (isLoading || !photoUrl) {
    return null;
  }

  return (
    <div className={`relative overflow-hidden rounded-lg ${className}`}>
      <img
        src={photoUrl}
        alt="Job preview"
        className="w-full h-full object-cover"
      />
    </div>
  );
};
